import { isDevelopmentEnvironment, isLocalhostEnvironment, isSandboxEnvironment } from 'utils/env';
import { Flags } from './flags.types';

function getServerlessDefaults() {
  return isDevelopmentEnvironment() || isSandboxEnvironment() || isLocalhostEnvironment();
}

// defaultFlags establishes default values for our supported feature flags.
export const getDefaultFlags = (): Flags => ({
  'always-true-flag': true,
  'day-zero-backend': false,
  'restrained-capacity-regions': false,
  'capella-enterprise-price-update': false,
  'enable-day-zero-private-dns': false,
  'enable-day-1-module-federation': false,
  'enable-udf-ui': false,
  'elixir-v2-experience': getServerlessDefaults(),
  dataApi: getServerlessDefaults(),
  'serverless-hibernation': getServerlessDefaults(),
  sso: true,
  'show-sso-signin-button': true,
  ssoPeopleList: true,
  eventing: false,
  billingV2: false,
  'backup-allow-daily-full': false,
  ephemeralBuckets: false,
  'provisioned-clusters-on-off': false,
  'app-services-maintenance-ui': false,
  'app-services-version-toggle': false,
  'xdcr-out': false,
  'disk-auto-scaling-toggle': false,

  playgroundRun: true,
  playgroundEdit: false,
  // Java is on by default so that if Launch Darkly is not configured
  // it will always show, but we can still disable it via Launch Darkly
  // if needed.
  playgroundLangJava: false,
  playgroundLangScala: false,
  playgroundLangDotNet: false,
  playgroundLangC: false,
  // The Nodejs flag is always on and currently not configured in
  // Launch Darkly. This is to ensure that we always show the Nodejs
  // example.
  playgroundLangNodejs: true,
  playgroundLangPhp: false,
  // Python is on by default so that if Launch Darkly is not configured
  // it will always show, but we can still disable it via Launch Darkly
  // if needed.
  playgroundLangPython: true,
  playgroundLangRuby: false,
  playgroundLangIosAndroid: false,
  playgroundLangSwift: false,
  playgroundLangObjectiveC: false,
  'customer-self-service-upgrades': false,
  'enable-global-backend-search': false,
  'in-house-feature-flags': false,
  'saml-enhancements': false,
  'single-node-app-services': false,
  'enable-ai-services-tab': false,
  'enable-iq-insights': false,
  'project-level-snapshot-backups': false,
  'multi-region-snapshot-backups': false,
  'sso-oidc': true,
  'credit-card-billing': false,
  'fts-morpheus-ui': false,
});
